import styled from 'styled-components';
import { Line } from 'react-chartjs-2';

export const StyledLine = styled(Line)`

`